import { ModuleLayout } from "layouts";
import TicketDetails from "./TicketDetails";

function TicketDetailsPage() {
  return (
    <ModuleLayout title="Ticket Details">
      <TicketDetails />
    </ModuleLayout>
  );
}
export default TicketDetailsPage;
